import { apiv2GetEnvelope } from '@/lib/apiv2';
import type { TaskInstance } from './endpoints';

export interface TaskPage {
  status: string;
  data: TaskInstance[];
  meta?: { count?: number | string | null };
}

export default async function getTaskPage(params: Record<string, unknown>): Promise<TaskPage> {
  return apiv2GetEnvelope('task-instances', params);
}
